import { render, staticRenderFns } from "./myOrders.vue?vue&type=template&id=6acfef2f&scoped=true&lang=true&"
import script from "./myOrders.vue?vue&type=script&lang=js&"
export * from "./myOrders.vue?vue&type=script&lang=js&"
import style0 from "./myOrders.vue?vue&type=style&index=0&id=6acfef2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acfef2f",
  null
  
)

export default component.exports